import createLucideIcon from '../createLucideIcon';

/**
 * @component @name WifiSync
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEuOTY1IDEwLjEwNXY0TDEzLjUgMTIuNWE1IDUgMCAwIDEgOCAxLjUiIC8+CiAgPHBhdGggZD0iTTExLjk2NSAxNC4xMDVoNCIgLz4KICA8cGF0aCBkPSJNMTcuOTY1IDE4LjEwNWg0TDIwLjQzIDE5LjcxYTUgNSAwIDAgMS04LTEuNSIgLz4KICA8cGF0aCBkPSJNMiA4LjgyYTE1IDE1IDAgMCAxIDIwIDAiIC8+CiAgPHBhdGggZD0iTTIxLjk2NSAyMi4xMDV2LTQiIC8+CiAgPHBhdGggZD0iTTUgMTIuODZhMTAgMTAgMCAwIDEgMy0yLjAzMiIgLz4KICA8cGF0aCBkPSJNOC41IDE2LjQyOWguMDEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/wifi-sync
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const WifiSync = createLucideIcon('wifi-sync', [
  ['path', { d: 'M11.965 10.105v4L13.5 12.5a5 5 0 0 1 8 1.5', key: '1immaq' }],
  ['path', { d: 'M11.965 14.105h4', key: 'uejny8' }],
  ['path', { d: 'M17.965 18.105h4L20.43 19.71a5 5 0 0 1-8-1.5', key: '1i3a7e' }],
  ['path', { d: 'M2 8.82a15 15 0 0 1 20 0', key: 'dnpr2z' }],
  ['path', { d: 'M21.965 22.105v-4', key: '1ku6vx' }],
  ['path', { d: 'M5 12.86a10 10 0 0 1 3-2.032', key: 'pemdtu' }],
  ['path', { d: 'M8.5 16.429h.01', key: '2bm739' }],
]);

export default WifiSync;
